import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'underscore';
import { PermissionHelper } from '../../shared/permissions/permissions';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { error, debug } from 'util';
import { months } from 'moment';
import { jsonpCallbackContext } from '@angular/common/http/src/module';
import { ScheduleReportComponent } from './scheduleReport';

@Component({
    selector: 'clear-Component',
    templateUrl: './clearComponent.html'
})
export class ClearCacheComponent implements OnInit {
    public _baseUrl: any;
    public time:any;
    public selectedReportFrequency: any;
    public dropdownList = [];
    public selectedItems = [];
    public dropdownSettings = {};
    public weeklyDropDownSettings = {};
    public dynamicDataList: any = {};
    public dynamicSelectedData: any = {};
    public fileType = false;
    public scheduleReport: any = {
        reportFrequencyEnum : null,
        startDate:null,
        scheduleTime:null,
        data:null,
        toEmails: null,
        ccEmails: null,
        bccEmails: null,
        olderExcelFormat:false
    }
    public validateEmails: any = {
        toEmails: null,
        ccEmails: null,
        bccEmails: null
    };
    public validEmailDetails: any;
    public showValidateButtonLoading:boolean = false;
    public showSendMailButtonLoading:boolean = false;
    public showSendButton:boolean = true;
    public reportId: any;
    public errorMessage:any;
    public showValidButton: boolean = false;
    public mailDetails: any;
    public weekDaysList : any = [];
    public frequenciesList: any = [];
    public selectedMonthIds: any = [];
    public shareValue = 'Select';
    public  dynamicId: any;
    public  weeks:any =  [] ;
    months: any;
    dynamicDataSettingsList: any;
    weekString: any;
    public selectedItemArray = [];
    public monthDays : any = [];
    public scheduledReports = [];
    public pageSize: number = 10;
    public page = 1;
    public startingPage: any = 1;
    public endingPage: any = 10;
    public collectionSize: any;
    public trackHides: any;

    constructor(
        public router: Router,
        public activeModal: NgbActiveModal,
        public _per: PermissionHelper,
        public _global: Configuration,
        public http: HttpClientCustom,
        public share: SharedData,
        public modalService: NgbModal,
        public translate: TranslateService,
        public _toaster: ToasterComponent, vcr: ViewContainerRef, public _location: Location) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
    }
    public ngOnInit() {  }
}



// WEBPACK FOOTER //
// ./src/app/tools/clearComponent/clearComponent.ts